import { Page } from '@app/components/page/Page';
import { GroupIcon } from '@app/components/users/GroupIcon';
import { fetchGroups } from '@app/modules/admin/api';
import { AddButton } from '@app/modules/admin/components/AddButton';
import { GroupsHelp } from '@app/modules/admin/components/GroupsHelp';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';
import { GroupsBreadcrumbs } from '../header';
import { AdminGroupsList } from './AdminGroupsList';

type Props = Record<string, never>;

export const AdminGroupsListPage = (p: Props) => {
  const { $t } = useIntl();

  const query = useQuery({
    queryKey: ['admin-groups'],
    queryFn: () => fetchGroups().then((res) => res),
    refetchOnMount: 'always',
  });

  return (
    <Page
      data-cy="groups-list-screen"
      htmlTitle={$t({
        id: 'admin.groups.listScreen.title',
        defaultMessage: 'Administrar grupos',
      })}
    >
      <Page.Header
        icon={<GroupIcon />}
        title={
          <>
            <FormattedMessage
              id="admin.groups.listScreen.title"
              defaultMessage="Administrar grupos"
            />
            <GroupsHelp
              linkText={
                <FormattedMessage
                  id="admin.groups.addScreen.helpLinkText"
                  defaultMessage="¿Qué es un grupo?"
                />
              }
            />
          </>
        }
        actions={
          <AddButton
            to="/admin/groups/add"
            label={$t({
              id: 'admin.groups.listScreen.links.createGroup',
              defaultMessage: 'Crear grupo',
            })}
          />
        }
        breadcrumbs={<GroupsBreadcrumbs />}
      />
      <Page.Content>
        <AdminGroupsList query={query} />
      </Page.Content>
    </Page>
  );
};
